import { SxProps } from '@mui/material';

import { IImage } from '@/components/ImageAsset/ImageAsset';
import { ImageAsset as TImageAsset } from '@/types/generated';
import { BlogImage } from '@/components/BlogDetailsPage';

import ImageAsset from '../ImageAsset';
import FocalPointImage from '../FocalPointImage';

export interface IBlogImage {
	imageAsset: TImageAsset;
	blogImage: BlogImage;
	imageAssetStyles?: SxProps;
	blogImageStyles?: SxProps;
	dataTestId: string;
}

const BlogImageCondition = ({ imageAsset, imageAssetStyles, blogImage, blogImageStyles, dataTestId }: IBlogImage) => {
	return imageAsset ? (
		<ImageAsset
			desktopImage={imageAsset?.desktopImage as IImage}
			mobileImage={imageAsset?.mobileImage as IImage}
			imageSx={imageAssetStyles}
			dataTestId={dataTestId}
		/>
	) : blogImage ? (
		<FocalPointImage
			brandFolderImage={blogImage?.image}
			focalPoint={blogImage?.focalPoint}
			imageSx={blogImageStyles}
			dataTestId={dataTestId}
		/>
	) : null;
};

export default BlogImageCondition;
